import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS, ROUTE_PATHS } from '@constants';
import { Button, Icon, Typography } from '@ui';
import { Flex } from 'antd';

const NotConnected = () => {
    const navigate = useNavigate();
    return (
        <Flex data-e2e='products_not-connected_section' vertical style={{ flexGrow: 1 }}>
            <Typography.Text type='em0'>Products</Typography.Text>
            <Flex align='center' justify='center' style={{ flexGrow: 1 }}>
                <Flex vertical align='center' gap={24}>
                    <Typography.Title level={2} color={COLORS.$gray60Black}>
                        Connect your store to Klickly to view your products
                    </Typography.Title>
                    <Button
                        data-e2e='products_complete-set-up_btn'
                        onClick={() => navigate(ROUTE_PATHS.INTEGRATIONS_SETTINGS)}
                        type='primary'
                        size='large'
                        iconRight={
                            <Icon size='24px' color={COLORS.$white} component={() => <Icon.ArrowForwardIcon />} />
                        }
                    >
                        Complete Set-Up
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default NotConnected;
